import axios from 'axios';
import createClient, { OrdermentumClient } from 'ordermentum-sdk';

export default class OmClient {
  private static instance: OrdermentumClient;

  static token: string;

  static setToken(token: string) {
    OmClient.token = token;
  }

  static getInstance(): OrdermentumClient {
    if (!OmClient.instance) {
      OmClient.instance = createClient({
        adaptor: axios,
        apiBase: process.env.API_BASE_URL,
        token: this.token,
        timeout: 120000,
      });
    }
    return OmClient.instance;
  }
}
